import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../component/users/Header";
import LoaderLayout from "../../component/users/LoaderLayout";
import LoaderLayout2 from "../../component/users/LoaderLayout2";
import Footer from "../../component/users/Footer";
import { Box, Button, Container } from "@mui/material";
import ViewClubComponent from "../../component/users/ViewClub/Index";
import { getClub } from "../../api/getClub";

const ViewTournament = () => {
  const { id } = useParams();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.user.loading);

  const [loading, setloading] = useState(true);

  const [club, setClub] = useState(null);

  const fetchClub = async (id, token) => {
    try {
      const data = await getClub(id, token);
      if (data.success) {
        setClub(data?.data);
      } else {
        toast.error(data.message);
        throw Error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchClub(id, token);
    } else {
      setloading(false);
      toast.error("Goal ID is missing");
    }
  }, [id]);

  return (
    <>
      <Header />

      {user ? (
        <LoaderLayout />
      ) : !loading ? (
        <Box className="userLayout addGoal">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743" }}
          >
            <Box className="leader-board-main">
              <Box className="leader-board-wrapper">
                <ViewClubComponent club={club} setClub={setClub} />
              </Box>
            </Box>
          </Container>
          <Footer />
        </Box>
      ) : (
        <LoaderLayout2 />
      )}
    </>
  );
};

export default ViewTournament;
